module.exports = __webpack_public_path__ + "img/isupplier-logo.35629d41.png";